import io from "socket.io-client";
const ws = io();

export default ws;
